import axios from "axios";

const API = process.env.REACT_APP_API_URL || "http://localhost:5000";
const axiosInstance = axios.create({ baseURL: API, withCredentials: true });

export const createPeriod = async (data) => {
  const res = await axiosInstance.post("/timetable/create", data);
  return res.data;
};

export const bulkCreateTimetable = async (data) => {
  const res = await axiosInstance.post("/timetable/bulk-create", data);
  return res.data;
};

export const getTimetableForSection = async (sectionId, dayOfWeek = "") => {
  const res = await axiosInstance.get(`/timetable/section/${sectionId}`, { params: { dayOfWeek } });
  return res.data;
};

export const getTimetableForTeacher = async (staffId) => {
  const res = await axiosInstance.get(`/timetable/teacher/${staffId}`);
  return res.data;
};

export const getVacantPeriods = async () => {
  const res = await axiosInstance.get("/timetable/vacant");
  return res.data;
};

export const getOngoingPeriods = async () => {
  const res = await axiosInstance.get("/timetable/ongoing");
  return res.data;
};

export const updatePeriod = async (id, data) => {
  const res = await axiosInstance.put(`/timetable/update/${id}`, data);
  return res.data;
};

export const deletePeriod = async (id) => {
  const res = await axiosInstance.delete(`/timetable/delete/${id}`);
  return res.data;
};
